import { Component, inject, OnInit } from '@angular/core';
import { DoctorsDashboardComponent } from '../doctors-dashboard/doctors-dashboard.component';
import { AuthService } from '../shared/auth/auth.service';
import { Router } from '@angular/router';
import { LabDashboardComponent } from '../lab-dashboard/lab-dashboard.component';
import { AdminDashboardComponent } from '../admin-dashboard/admin-dashboard.component';
import { PatientDashboardComponent } from '../patient-dashboard/patient-dashboard.component';
import { PharmacyDashboardComponent } from '../pharmacy-dashboard/pharmacy-dashboard.component';
import { NurseDashboardComponent } from '../nurse-dashboard/nurse-dashboard.component';
import { ConsultantDashboardComponent } from '../consultant-dashboard/consultant-dashboard.component';
import { CashierDashboardComponent } from '../cashier-dashboard/cashier-dashboard.component';
import { InfoDialogService } from '../shared/info-dialog/info-dialog.service';
import { CommonModule } from '@angular/common';
import { ServiceproviderDashboardComponent } from '../serviceprovider-dashboard/serviceprovider-dashboard.component';
import { ReceptionistDashboardComponent } from '../receptionist-dashboard/receptionist-dashboard.component';
import { SuperAdminDashboardComponent } from '../admin-dashboard/superadmin-dashboard/superadmin-dashboard.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import {EventManagerDashboardComponent} from '../eventmanager-dashboard/eventManager-dashboard.component';
import { GlobalEventManagerDashboardComponent } from '../global-event-manager-dashboard/global-event-manager-dashboard.component';

@Component({
  selector: 'app-dashboards-wrapper',
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    DoctorsDashboardComponent,
    CashierDashboardComponent,
    NurseDashboardComponent,
    LabDashboardComponent,
    AdminDashboardComponent,
    ConsultantDashboardComponent,
    PatientDashboardComponent,
    PharmacyDashboardComponent,
    ServiceproviderDashboardComponent,
    ReceptionistDashboardComponent,
    SuperAdminDashboardComponent,
    EventManagerDashboardComponent,
    GlobalEventManagerDashboardComponent
  ],
  templateUrl: './dashboards-wrapper.component.html',
  styleUrl: './dashboards-wrapper.component.scss'
})
export class DashboardsWrapperComponent implements OnInit {
  auth = inject(AuthService);
  router = inject(Router);
  infoDialog = inject(InfoDialogService);
  role: any;
  user: any;

  // Roles that have a fully implemented dashboard
  private readonly implementedDashboardRoles = [
    'hospitaladmin', 'doctor', 'healthcareassistant', 'pharmacist', 'labtechnician',
    'healthcareadmin', 'patient', 'pharmacy', 'remotedoctor',
    'cashier', 'alliedhealthprofessional', 'superadmin', 'nursemidwife','eventmanager','globaleventmanager'
  ];

  ngOnInit() {
    this.auth.user.subscribe((e) => {
      this.user = e;
    });
    this.user = this.auth.user.getValue();

    if (this.user == null) {
      this.router.navigate(["/login"]);
      return;
    }

    const role = (this.user?.role ?? '').toLowerCase();
    if (role === 'cashier') {
      this.router.navigate(['/app/profit-margins']);
      return;
    }

    if (!this.implementedDashboardRoles.includes(role)) {
      this.infoDialog.show(
        'The dashboard for your role is currently under construction. Check back soon!',
        {
          title: '🚧 Dashboard Under Construction',
          duration: 0
        }
      );
    }
  }

  // Method to navigate to documentation
  goToDocumentation(section: string = 'getting-started'): void {
    this.router.navigate(['/documentation', section]);
  }
}